// Edit the colors here to change global theming for the navbar component

export const primary = "";
export const secondary = "";

export const background = "";
export const textColor = "";

export const fontFamily = `"Comfortaa", cursive;`;
export const headerFontFamily = `"Antonio", sans-serif;`;